export default function(o, done){

  o.svgs = {
    play: {
      file: 'frontend-play.svg',
    },
    stop: {
      file: 'frontend-stop.svg',
    },
    soundOn: {
      file: 'frontend-sound-on.svg',
    },
    soundOff: {
      file: 'frontend-sound-off.svg',
    },
    search: {
      file: 'frontend-search.svg',
    },
    caretLeft: {
      file: 'frontend-caret-left.svg',
    },
    caretRight: {
      file: 'frontend-caret-right.svg',
    },
    caretDown: {
      file: 'frontend-caret-down.svg',
    },
  }

  var serverUrl = o.util.getUrl('asset')

  var totalSvgsLoaded = 0

  var prepareSvg = function(id){

    var s = o.svgs[id]

    $('<div>')
    .load(`${serverUrl}${s.file}`, function(){
      o.svgs[id].svg = $($(this).html())
      if(++totalSvgsLoaded == _.size(o.svgs)){
        done()
      }
    })

  }

  for (var svg in o.svgs) {
    prepareSvg(svg)
  }

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/app/svgs.js